module.exports = __webpack_public_path__ + "img/snorkeling-3.780a7c00.jpeg";